import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { ProcessTemplateImportFileHelperContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/bl_mrp_process_template_import_file_helper_container.model';

@Injectable({
    providedIn: 'root'
})
export class ProcessTemplateImportFileHelperService extends BaseApiTemplateService<ProcessTemplateImportFileHelperContainerModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + 'mrp-process-template/import-file-helpers/backoffice-ep'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + 'mrp-process-template/import-file-helpers/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + 'mrp-process-template/import-file-helpers/backoffice-ep';
        this.httpClient = http;
    }

}

